module.exports = __webpack_public_path__ + "img/entertainment-2.e5b9b681.jpg";